// src/components/Task.jsx
import React, { useState, useEffect, useRef } from "react";
import "./Task.css";
import { FaTimes, FaCopy, FaCalendarAlt, FaExpand, FaCompress } from "react-icons/fa";
import { supabase } from "../supabaseClient";
import Loading from "./Loading";
import ComentariosSection from "./TaskComentarios";
import TaskAnexos from "./TaskAnexos";
import { buscarConfirmacoesPorNotas } from "../utils/ciencia"; // NOVO IMPORT
import TaskOriginBadge from "./TaskOriginBadge"; // NOVO IMPORT
import { MdPersonAddAlt1 } from "react-icons/md";
import { FaBold, FaItalic, FaListUl } from "react-icons/fa";

const CORES_TEXTO_TASK = ["#1e293b", "#dc2626", "#2563eb", "#16a34a", "#d97706", "#9333ea"];

export default function Task({
  onClose,
  projetoAtual,
  notaAtual,
  containerId: containerIdProp,
  setColumnsNormais,
  setColumnsArquivadas
}) {
  const [descricao, setDescricao] = useState("");
  const [telaCheia, setTelaCheia] = useState(false);
  const [editandoDescricao, setEditandoDescricao] = useState(false);
  const descricaoRef = useRef(null);
  const [anexosSalvos, setAnexosSalvos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [meuNome, setMeuNome] = useState("Você");
  const [dataEntregaTarefa, setDataEntregaTarefa] = useState("");
  const [imagemAmpliada, setImagemAmpliada] = useState(null);
  const [containerIdValidado, setContainerIdValidado] = useState(null);
  const [containerName, setContainerName] = useState("");
  const [responsaveisTarefa, setResponsaveisTarefa] = useState([]);
  const [showInputResponsaveis, setShowInputResponsaveis] = useState(false);
  const [inputResponsavelTarefa, setInputResponsavelTarefa] = useState("");
  const [sugestoesMembros, setSugestoesMembros] = useState([]);
  const modalRef = useRef(null);
  const inputRef = useRef(null);
  const bodyRef = useRef(null);
  const [larguraComentarios, setLarguraComentarios] = useState(() => {
    const salvo = localStorage.getItem("task_largura_comentarios");
    return salvo ? Number(salvo) : 500;
  });
  const [arrastandoDivisorTask, setArrastandoDivisorTask] = useState(false);

  const [objetivos, setObjetivos] = useState([]);
  const [showObjetivos, setShowObjetivos] = useState(false);
  const [novoObjetivoTexto, setNovoObjetivoTexto] = useState("");
  const [inputResponsavel, setInputResponsavel] = useState({});
  const [sugestoesResponsavel, setSugestoesResponsavel] = useState({});

  const [criadorNome, setCriadorNome] = useState("");
  const [dataCriacao, setDataCriacao] = useState("");

  // Estados para copiar tarefa
  const [showCopiarPicker, setShowCopiarPicker] = useState(false);
  const [etapaCopiar, setEtapaCopiar] = useState("entidade"); // "entidade" | "pilha"
  const [destinosDisponiveis, setDestinosDisponiveis] = useState({ projetos: [], setores: [] });
  const [entidadeSelecionada, setEntidadeSelecionada] = useState(null); // { id, name, tipo }
  const [pilhasDisponiveis, setPilhasDisponiveis] = useState([]);
  const [copiando, setCopiando] = useState(false);
  const [copiaConcluida, setCopiaConcluida] = useState(false);
  const copiarRef = useRef(null);

  // NOVO ESTADO - usuários que confirmaram ciência
  const [usuariosCientes, setUsuariosCientes] = useState(new Set());

  // NOVO ESTADO — ids de quem está ativo no container (dono + convidados aceitos)
  const [colaboradoresAtivosIds, setColaboradoresAtivosIds] = useState(new Set());

  // ── HANDLER DO DIVISOR REDIMENSIONÁVEL ──
  const handleDividerMouseDownTask = (e) => {
    e.preventDefault();
    setArrastandoDivisorTask(true);
  };

  useEffect(() => {
    if (!arrastandoDivisorTask) return;

    const handleMouseMove = (e) => {
      if (!bodyRef.current) return;
      const rect = bodyRef.current.getBoundingClientRect();
      const novaLargura = rect.right - e.clientX;
      const min = 280;
      const max = rect.width - 320;
      setLarguraComentarios(Math.min(Math.max(novaLargura, min), max));
    };

    const handleMouseUp = () => {
      setArrastandoDivisorTask(false);
      localStorage.setItem("task_largura_comentarios", String(larguraComentarios));
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [arrastandoDivisorTask, larguraComentarios]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (showInputResponsaveis && inputRef.current && !inputRef.current.contains(e.target)) {
        setShowInputResponsaveis(false);
        setInputResponsavelTarefa("");
        setSugestoesMembros([]);
      }
    };
    if (showInputResponsaveis) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [showInputResponsaveis]);

  // Fechar copiar ao clicar fora
  useEffect(() => {
    const handler = (e) => {
      if (copiarRef.current && !copiarRef.current.contains(e.target)) {
        setShowCopiarPicker(false);
        setEtapaCopiar("entidade");
      }
    };
    if (showCopiarPicker) {
      document.addEventListener("mousedown", handler);
      return () => document.removeEventListener("mousedown", handler);
    }
  }, [showCopiarPicker]);

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        setUserId(user.id);
        const { data: profile } = await supabase
          .from("profiles")
          .select("nome, nickname, avatar_url, container")
          .eq("id", user.id)
          .single();
        const safeProfile = profile || { nome: "Você", nickname: "usuario", avatar_url: null, container: "" };
        setUserProfile(safeProfile);
        setMeuNome(safeProfile.nome || "Você");
      }
    };
    fetchUser();
  }, []);

  // NOVO useEffect - busca quem já confirmou ciência
  useEffect(() => {
    if (!notaAtual?.id) {
      setUsuariosCientes(new Set());
      return;
    }
    buscarConfirmacoesPorNotas([notaAtual.id]).then((map) => {
      setUsuariosCientes(map.get(notaAtual.id) || new Set());
    });
  }, [notaAtual?.id, responsaveisTarefa.length]);

  useEffect(() => {
    if (!notaAtual?.id) {
      setContainerIdValidado(null);
      setContainerName("");
      setResponsaveisTarefa([]);
      return;
    }
    const fetchContainerData = async () => {
      const { data: nota, error: notaError } = await supabase
        .from("notas")
        .select("container_id")
        .eq("id", notaAtual.id)
        .single();
      if (notaError || !nota?.container_id) {
        setContainerIdValidado(null);
        setContainerName("");
        return;
      }
      const containerId = nota.container_id;
      setContainerIdValidado(containerId);
      const { data: container } = await supabase
        .from("containers")
        .select("name")
        .eq("id", containerId)
        .single();
      setContainerName(container?.name || "Sem container");

      // ── NOVO: quem está ativo no container agora ──
      const { data: convitesAtivos } = await supabase
        .from("convites")
        .select("user_id")
        .eq("container_id", containerId)
        .eq("status", "aceito");
      const ativosSet = new Set([containerId, ...(convitesAtivos || []).map(c => c.user_id).filter(Boolean)]);
      setColaboradoresAtivosIds(ativosSet);

      const { data: responsaveis } = await supabase
        .from("nota_responsaveis")
        .select("usuario_id")
        .eq("nota_id", notaAtual.id);
      if (responsaveis?.length > 0) {
        const userIds = responsaveis.map(r => r.usuario_id);
        const { data: profiles } = await supabase
          .from("profiles")
          .select("id, nome, nickname, avatar_url")
          .in("id", userIds);
        setResponsaveisTarefa(
          (profiles || []).map(p => ({ ...p, removido: !ativosSet.has(p.id) }))
        );
      } else {
        setResponsaveisTarefa([]);
      }
    };
    fetchContainerData();
  }, [notaAtual?.id]);

  useEffect(() => {
    if (!notaAtual?.id) {
      setDescricao("");
      setAnexosSalvos([]);
      setDataEntregaTarefa("");
      setCriadorNome("");
      setDataCriacao("");
      return;
    }
    let isMounted = true;
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: nota, error: notaError } = await supabase
          .from("notas")
          .select("descricao, data_entrega, created_at, created_by, responsavel_id")
          .eq("id", notaAtual.id)
          .single();
        if (isMounted && nota) {
          setDescricao(nota.descricao || "");
          setDataEntregaTarefa(nota.data_entrega || "");
          setDataCriacao(nota.created_at || "");
          let criadorId = nota.created_by || nota.responsavel_id;
          if (!criadorId) {
            const { data: primeiroResp } = await supabase
              .from("nota_responsaveis")
              .select("usuario_id")
              .eq("nota_id", notaAtual.id)
              .limit(1)
              .single();
            criadorId = primeiroResp?.usuario_id;
          }
          if (criadorId) {
            const { data: criadorProfile } = await supabase
              .from("profiles")
              .select("nome, nickname")
              .eq("id", criadorId)
              .single();
            setCriadorNome(criadorProfile?.nickname || criadorProfile?.nome || "Usuário");
          } else {
            setCriadorNome("");
          }
        }
        const { data: anexos } = await supabase
          .from("anexos")
          .select("id, file_name, file_url, mime_type")
          .eq("nota_id", notaAtual.id)
          .order("created_at", { ascending: true });
        if (isMounted) setAnexosSalvos(anexos || []);
      } catch (err) {
        console.error("Erro ao carregar dados da nota:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    fetchData();
    return () => { isMounted = false; };
  }, [notaAtual?.id]);

  useEffect(() => {
    if (!notaAtual?.id || !containerIdValidado) {
      setObjetivos([]);
      setShowObjetivos(false);
      return;
    }
    const fetchObjetivos = async () => {
      setLoading(true);
      try {
        const { data: checklist } = await supabase
          .from("checklists")
          .select("id")
          .eq("nota_id", notaAtual.id)
          .single();
        if (!checklist) { setObjetivos([]); setShowObjetivos(false); return; }
        const { data: items } = await supabase
          .from("checklist_items")
          .select("*")
          .eq("checklist_id", checklist.id)
          .order("created_at", { ascending: true });
        if (!items || items.length === 0) { setObjetivos([]); setShowObjetivos(false); return; }
        const itemIds = items.map(i => i.id);
        let respMap = {};
        if (itemIds.length > 0) {
          const { data: responsaveis } = await supabase
            .from("checklist_responsaveis")
            .select("*")
            .in("checklist_item_id", itemIds);
          if (responsaveis && responsaveis.length > 0) {
            const userIds = responsaveis.filter(r => r.usuario_id).map(r => r.usuario_id);
            let profilesMap = {};
            if (userIds.length > 0) {
              const { data: profiles } = await supabase
                .from("profiles")
                .select("id, nome, nickname")
                .in("id", userIds);
              if (profiles) {
                profilesMap = profiles.reduce((acc, p) => { acc[p.id] = p; return acc; }, {});
              }
            }
            respMap = responsaveis.reduce((acc, r) => {
              if (!acc[r.checklist_item_id]) acc[r.checklist_item_id] = [];
              let nomeExibicao;
              let nome = null, nickname = null;
              if (r.usuario_id && profilesMap[r.usuario_id]) {
                const profile = profilesMap[r.usuario_id];
                nome = profile.nome; nickname = profile.nickname;
                nomeExibicao = profile.nickname || profile.nome || "Usuário";
              } else if (r.nome_externo) {
                nomeExibicao = r.nome_externo;
              } else {
                nomeExibicao = "Usuário";
              }
              acc[r.checklist_item_id].push({ id: r.id, usuario_id: r.usuario_id, nome_externo: r.nome_externo, nome_exibicao: nomeExibicao, nome, nickname });
              return acc;
            }, {});
          }
        }
        const objetivosCompletos = items.map(item => ({
          id: item.id, texto: item.description || "", concluido: item.is_completed || false,
          dataEntrega: item.data_entrega || null, responsaveis: respMap[item.id] || [], checklist_id: checklist.id
        }));
        setObjetivos(objetivosCompletos);
        setShowObjetivos(objetivosCompletos.length > 0);
      } catch (err) {
        console.error("Erro ao carregar objetivos:", err);
        setObjetivos([]);
        setShowObjetivos(false);
      } finally {
        setLoading(false);
      }
    };
    fetchObjetivos();
  }, [notaAtual?.id, containerIdValidado]);

  useEffect(() => {
    setShowObjetivos(objetivos.length > 0);
  }, [objetivos.length]);

  // Funções de copiar tarefa
  const abrirPickerCopiar = async () => {
    if (!containerIdValidado) return;
    const [{ data: projetos }, { data: setores }] = await Promise.all([
      supabase.from("projects").select("id, name").eq("user_id", containerIdValidado),
      supabase.from("setores").select("id, name").eq("user_id", containerIdValidado),
    ]);
    setDestinosDisponiveis({ projetos: projetos || [], setores: setores || [] });
    setEtapaCopiar("entidade");
    setCopiaConcluida(false);
    setShowCopiarPicker(true);
  };

  const selecionarEntidadeCopiar = async (entidade, tipo) => {
    setEntidadeSelecionada({ ...entidade, tipo });
    const idField = tipo === "project" ? "project_id" : "setor_id";
    const { data: pilhas } = await supabase.from("pilhas")
      .select("id, title, ordem")
      .eq(idField, entidade.id)
      .neq("title", "Recebidos")
      .or("arquivada.is.null,arquivada.eq.false")
      .order("ordem", { ascending: true });
    setPilhasDisponiveis(pilhas || []);
    setEtapaCopiar("pilha");
  };

  const copiarTarefaParaPilha = async (pilhaDestino) => {
    setCopiando(true);
    try {
      const { data: notaOriginal } = await supabase.from("notas").select("*").eq("id", notaAtual.id).single();
      if (!notaOriginal) throw new Error("Nota original não encontrada.");

      const { data: notaNova, error: errNota } = await supabase.from("notas").insert({
        nome: `${notaOriginal.nome} (cópia)`,
        tipo: notaOriginal.tipo,
        pilha_id: pilhaDestino.id,
        descricao: notaOriginal.descricao,
        data_entrega: notaOriginal.data_entrega,
        container_id: containerIdValidado,
        created_by: userId,
        concluida: false,
        ordem: 0,
      }).select().single();
      if (errNota) throw errNota;

      if (responsaveisTarefa.length) {
        await supabase.from("nota_responsaveis").insert(
          responsaveisTarefa.map(r => ({ nota_id: notaNova.id, usuario_id: r.id }))
        );
      }

      const { data: checklistOriginal } = await supabase.from("checklists").select("id").eq("nota_id", notaAtual.id).single();
      if (checklistOriginal) {
        const { data: checklistNovo } = await supabase.from("checklists")
          .insert({ nota_id: notaNova.id, container_id: containerIdValidado }).select("id").single();
        if (checklistNovo) {
          for (const obj of objetivos) {
            const { data: itemNovo } = await supabase.from("checklist_items").insert({
              checklist_id: checklistNovo.id,
              description: obj.texto,
              is_completed: false,
              data_entrega: obj.dataEntrega,
              ordem: 0,
            }).select().single();
            if (itemNovo && obj.responsaveis?.length) {
              await supabase.from("checklist_responsaveis").insert(
                obj.responsaveis.map(r => ({
                  checklist_item_id: itemNovo.id,
                  usuario_id: r.usuario_id || null,
                  nome_externo: r.nome_externo || null
                }))
              );
            }
          }
        }
      }

      // Inserir na coluna local
      if (typeof setColumnsNormais === "function") {
        setColumnsNormais(prev => {
          const existeColuna = prev.some(c => String(c.id) === String(pilhaDestino.id));
          if (!existeColuna) return prev;
          return prev.map(c =>
            String(c.id) === String(pilhaDestino.id)
              ? { ...c, notas: [notaNova, ...c.notas] }
              : c
          );
        });
      }

      setCopiando(false);
      setCopiaConcluida(true);
      setTimeout(() => {
        setShowCopiarPicker(false);
        setEtapaCopiar("entidade");
        setCopiaConcluida(false);
      }, 1500);
    } catch (err) {
      console.error("Erro ao copiar tarefa:", err);
      alert("Erro ao copiar a tarefa.");
      setCopiando(false);
    }
  };

  const handleInputResponsavelChange = (e) => {
    const valor = e.target.value;
    setInputResponsavelTarefa(valor);
    if (valor.startsWith("@") && valor.length > 1 && containerIdValidado) {
      const termo = valor.slice(1).toLowerCase();
      supabase.from("convites").select("user_id").eq("container_id", containerIdValidado).eq("status", "aceito")
        .then(async ({ data: convites }) => {
          const userIds = convites?.map(c => c.user_id).filter(Boolean) || [];
          if (userIds.length === 0) { setSugestoesMembros([]); return; }
          const { data: profiles } = await supabase.from("profiles").select("id, nome, nickname, avatar_url").in("id", userIds);
          const sugestoes = profiles?.filter(p => (p.nickname?.toLowerCase().includes(termo)) || (p.nome?.toLowerCase().includes(termo))) || [];
          setSugestoesMembros(sugestoes.slice(0, 5));
        });
    } else {
      setSugestoesMembros([]);
    }
  };

  const adicionarResponsavelTarefa = async (perfil) => {
    if (responsaveisTarefa.some(r => r.id === perfil.id)) return;
    setResponsaveisTarefa(prev => [...prev, { id: perfil.id, nome: perfil.nome, nickname: perfil.nickname, avatar_url: perfil.avatar_url, removido: false }]);
    try {
      await supabase.from("nota_responsaveis").insert({ nota_id: notaAtual.id, usuario_id: perfil.id });
      const nomeTarefa = getNomeNota();
      const nomeProjeto = getNomeProjeto();
      const mensagem = containerName
        ? `Você foi adicionado a tarefa "${nomeTarefa}" do projeto "${nomeProjeto}" da container "${containerName}" por ${meuNome}.`
        : `Você foi adicionado a tarefa "${nomeTarefa}" do projeto "${nomeProjeto}" por ${meuNome}.`;
      await supabase.from("notificacoes").insert({
        user_id: perfil.id, remetente_id: userId, mensagem,
        projeto_id: projetoAtual?.id || null, nota_id: notaAtual.id, tipo: "atribuição", lido: false,
        url: `/container/${containerIdValidado}/projeto/${projetoAtual?.id}/nota/${notaAtual.id}`
      });
    } catch (err) {
      console.error("Erro ao atribuir responsável:", err);
      setResponsaveisTarefa(prev => prev.filter(r => r.id !== perfil.id));
    }
    setInputResponsavelTarefa("");
    setSugestoesMembros([]);
  };

  const removerResponsavelTarefa = async (usuarioId) => {
    setResponsaveisTarefa(prev => prev.filter(r => r.id !== usuarioId));
    try {
      await supabase.from("nota_responsaveis").delete().eq("nota_id", notaAtual.id).eq("usuario_id", usuarioId);
    } catch (err) {
      console.error("Erro ao remover responsável:", err);
    }
  };

  const handleSaveDescricao = async () => {
    const html = descricaoRef.current?.innerHTML || "";
    setDescricao(html);
    setEditandoDescricao(false);
    if (!notaAtual?.id) return;
    try {
      await supabase.from("notas").update({ descricao: html || null }).eq("id", notaAtual.id);
    } catch (err) {
      console.error("Erro ao salvar descrição:", err);
    }
  };

  const abrirEdicaoDescricao = () => {
    setEditandoDescricao(true);
    setTimeout(() => {
      if (descricaoRef.current) {
        descricaoRef.current.innerHTML = descricao;
        descricaoRef.current.focus();
      }
    }, 0);
  };

  const aplicarFormatacaoDescricao = (comando, valor = null) => {
    document.execCommand(comando, false, valor);
    descricaoRef.current?.focus();
  };

  const aplicarAlinhamentoDescricao = (alinhamento) => {
    document.execCommand("justify" + alinhamento, false, null);
    descricaoRef.current?.focus();
  };

  const handleSalvarDataEntregaTarefa = async (novaData) => {
    if (!notaAtual?.id) return;
    try {
      await supabase.from("notas").update({ data_entrega: novaData || null }).eq("id", notaAtual.id);
      setDataEntregaTarefa(novaData || "");
      const updateColumns = (setter) => {
        if (setter) {
          setter(prev => prev.map(col => {
            const notaIndex = col.notas.findIndex(n => n.id === notaAtual.id);
            if (notaIndex === -1) return col;
            const updatedNotas = [...col.notas];
            updatedNotas[notaIndex] = { ...updatedNotas[notaIndex], data_entrega: novaData || null };
            return { ...col, notas: updatedNotas };
          }));
        }
      };
      updateColumns(setColumnsNormais);
      updateColumns(setColumnsArquivadas);
    } catch (err) {
      console.error("Erro ao salvar data de entrega:", err);
    }
  };

  const formatarDataCriacao = (dataISO) => {
    if (!dataISO) return "";
    return new Date(dataISO).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
  };

  const getNomeProjeto = () => projetoAtual?.nome || projetoAtual?.name || "Sem projeto";
  const getNomeNota = () => notaAtual?.nome || notaAtual?.name || "Sem nota";

  if (loading || (notaAtual?.id && containerIdValidado === null)) {
    return (
      <div className="task-modal" ref={modalRef}>
        <div className="task-loading-container">
          <Loading size={200} />
        </div>
      </div>
    );
  }

  return (
    <div className={`task-modal${telaCheia ? " task-modal--tela-cheia" : ""}`} ref={modalRef}>
      {/* ── HEADER ── */}
      <div className="task-header">
        <div className="task-header-left">
          <div className="task-header-titles">
            <span className="task-header-title">{getNomeNota()}</span>
            <span className="task-header-sub">{getNomeProjeto()}</span>
          </div>
        </div>
        <div className="task-header-right" style={{ position: "relative" }} ref={copiarRef}>
          <button className="task-close-btn" onClick={abrirPickerCopiar} title="Copiar tarefa">
            <FaCopy />
          </button>
          <button
            className="task-close-btn"
            onClick={() => setTelaCheia((v) => !v)}
            title={telaCheia ? "Restaurar modal" : "Tela cheia"}
            aria-label={telaCheia ? "Restaurar modal" : "Tela cheia"}
          >
            {telaCheia ? <FaCompress /> : <FaExpand />}
          </button>
          {onClose && (
            <button className="task-close-btn" onClick={onClose} aria-label="Fechar">
              <FaTimes />
            </button>
          )}

          {showCopiarPicker && (
            <div className="menu-atas-disponiveis" style={{ top: "100%", right: 0 }}>
              {copiando ? (
                <div className="menu-atas-vazio">
                  <span className="spinner-comentario" style={{ borderTopColor: "#1565c0" }} /> Copiando...
                </div>
              ) : copiaConcluida ? (
                <div className="menu-atas-vazio" style={{ color: "#16a34a", fontStyle: "normal" }}>✓ Tarefa copiada!</div>
              ) : etapaCopiar === "entidade" ? (
                <>
                  <div className="menu-atas-header">
                    <span>Copiar para qual projeto/setor?</span>
                    <button onClick={() => setShowCopiarPicker(false)}>×</button>
                  </div>
                  {destinosDisponiveis.projetos.length === 0 && destinosDisponiveis.setores.length === 0 && (
                    <div className="menu-atas-vazio">Nenhum projeto ou setor disponível</div>
                  )}
                  {destinosDisponiveis.projetos.map(p => (
                    <div key={`p-${p.id}`} className="menu-atas-item" onClick={() => selecionarEntidadeCopiar(p, "project")}>
                      <div className="menu-atas-nome">{p.name}</div>
                      <div className="menu-atas-pauta">Projeto</div>
                    </div>
                  ))}
                  {destinosDisponiveis.setores.map(s => (
                    <div key={`s-${s.id}`} className="menu-atas-item" onClick={() => selecionarEntidadeCopiar(s, "setor")}>
                      <div className="menu-atas-nome">{s.name}</div>
                      <div className="menu-atas-pauta">Setor</div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  <div className="menu-atas-header">
                    <span>Copiar para qual pilha?</span>
                    <button onClick={() => setEtapaCopiar("entidade")}>‹</button>
                  </div>
                  {pilhasDisponiveis.length === 0 && (
                    <div className="menu-atas-vazio">Nenhuma pilha disponível em {entidadeSelecionada?.name}</div>
                  )}
                  {pilhasDisponiveis.map(p => (
                    <div key={p.id} className="menu-atas-item" onClick={() => copiarTarefaParaPilha(p)}>
                      <div className="menu-atas-nome">{p.title}</div>
                    </div>
                  ))}
                </>
              )}
            </div>
          )}
        </div>
      </div>

      {/* ── BODY: duas colunas ── */}
      <div className="task-body" ref={bodyRef}>
        {/* ── COLUNA ESQUERDA ── */}
        <div className="task-col-left">

          {/* Título + responsáveis + data */}
          <div className="task-meta-row">
            <div className="task-icon-title">
              <div className="task-icon-badge" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="3"/>
                  <path d="M9 12l2 2 4-4"/>
                </svg>
              </div>
              <h2 className="task-title">{getNomeNota()}</h2>
            </div>
            <div className="task-meta-controls">
              {/* Responsáveis */}
              <div className="grupo-responsaveis-tarefa" style={{ position: "relative" }}>
                {responsaveisTarefa.map(resp => {
                    const ciente = usuariosCientes.has(resp.id);
                    return (
                      <div
                        key={resp.id}
                        className={`avatar-responsavel-wrapper ${ciente ? "avatar-responsavel--ciente" : ""} ${resp.removido ? "avatar-responsavel--removido" : ""}`}
                        title={
                          resp.removido
                            ? `Usuário removido do container — ${resp.nickname || resp.nome}`
                            : `${resp.nickname || resp.nome}${ciente ? " · Ciente" : ""}`
                        }
                        onClick={() => removerResponsavelTarefa(resp.id)}
                      >
                        <div className="avatar-responsavel">
                          {resp.removido ? (
                            <div className="avatar-placeholder avatar-placeholder--sombra">?</div>
                          ) : resp.avatar_url ? (
                            <img src={resp.avatar_url} alt={resp.nickname || resp.nome} />
                          ) : (
                            <div className="avatar-placeholder">
                              {(resp.nickname || resp.nome || '?').charAt(0).toUpperCase()}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                <button
                  type="button"
                  className="btn-adicionar-responsavel"
                  onClick={() => setShowInputResponsaveis(!showInputResponsaveis)}
                  disabled={loading || !containerIdValidado}
                  title="Adicionar responsáveis"
                >
                  <MdPersonAddAlt1 />
                </button>

                {showInputResponsaveis && (
                  <div ref={inputRef} className="input-responsavel-flutuante">
                    <input
                      type="text"
                      value={inputResponsavelTarefa}
                      onChange={handleInputResponsavelChange}
                      placeholder="Digite @ para mencionar"
                      autoFocus
                    />
                    {sugestoesMembros.length > 0 && (
                      <div className="sugestoes-responsaveis-lista">
                        {sugestoesMembros.map(perfil => (
                          <div key={perfil.id} onClick={() => adicionarResponsavelTarefa(perfil)} className="sugestao-responsavel-item">
                            {perfil.avatar_url ? (
                              <img src={perfil.avatar_url} alt={perfil.nickname || perfil.nome} />
                            ) : (
                              <div className="avatar-placeholder-small">
                                {(perfil.nickname || perfil.nome || '?').charAt(0).toUpperCase()}
                              </div>
                            )}
                            <span>{perfil.nickname || perfil.nome}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Data de entrega — só ícone, sem digitação */}
              <label className="obj-data-label" style={{ fontSize: 13 }}>
                {dataEntregaTarefa && (
                  <span className="obj-data-texto">
                    {dataEntregaTarefa.split("-").reverse().join("/")}
                  </span>
                )}
                <FaCalendarAlt className="obj-data-icon" />
                <input
                  type="date"
                  className="obj-date-trigger"
                  value={dataEntregaTarefa || ""}
                  onChange={(e) => {
                    setDataEntregaTarefa(e.target.value);
                    handleSalvarDataEntregaTarefa(e.target.value || null);
                  }}
                  disabled={loading}
                />
              </label>
            </div>
          </div>

          {/* Separador */}
          <div className="task-divider" />

          {/* ── Descrição ── */}
            <div className="descricao-section">
              <div className="section-label">
                <span>Descrição</span>
              </div>

              {editandoDescricao ? (
                <div className="task-desc-edit-wrapper" onClick={(e) => e.stopPropagation()}>
                  <div
                    ref={descricaoRef}
                    className="task-desc-editable"
                    contentEditable
                    suppressContentEditableWarning
                    onBlur={handleSaveDescricao}
                  />
                  <div className="task-desc-toolbar">
                    <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => aplicarFormatacaoDescricao("bold")} title="Negrito"><FaBold size={12} /></button>
                    <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => aplicarFormatacaoDescricao("italic")} title="Itálico"><FaItalic size={12} /></button>
                    <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => aplicarFormatacaoDescricao("insertUnorderedList")} title="Lista"><FaListUl size={12} /></button>
                    <span className="task-desc-toolbar-divider" />
                    <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => aplicarAlinhamentoDescricao("Left")} title="Alinhar à esquerda"><span className="material-symbols-outlined" style={{ fontSize: 14 }}>format_align_left</span></button>
                    <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => aplicarAlinhamentoDescricao("Center")} title="Centralizar"><span className="material-symbols-outlined" style={{ fontSize: 14 }}>format_align_center</span></button>
                    <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => aplicarAlinhamentoDescricao("Right")} title="Alinhar à direita"><span className="material-symbols-outlined" style={{ fontSize: 14 }}>format_align_right</span></button>
                    <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => aplicarAlinhamentoDescricao("Justify")} title="Justificado"><span className="material-symbols-outlined" style={{ fontSize: 14 }}>format_align_justify</span></button>
                    <span className="task-desc-toolbar-divider" />
                    {CORES_TEXTO_TASK.map((c) => (
                      <button key={c} type="button" className="task-desc-toolbar-cor" style={{ background: c }} onMouseDown={e => e.preventDefault()} onClick={() => aplicarFormatacaoDescricao("foreColor", c)} />
                    ))}
                  </div>
                </div>
              ) : (
                <div
                  className="task-desc-rendered"
                  onClick={abrirEdicaoDescricao}
                  dangerouslySetInnerHTML={{ __html: descricao || "<span class='task-desc-placeholder'>Clique aqui para adicionar uma descrição...</span>" }}
                />
              )}

              {/* ── NOVO: Componente de Origem ── */}
              {notaAtual?.id && <TaskOriginBadge notaId={notaAtual.id} />}
            </div>
          

          <div className="task-divider" />

          {/* Anexos */}
          {containerIdValidado && (
            <TaskAnexos
              notaAtual={notaAtual}
              userId={userId}
              loading={loading}
              anexosSalvos={anexosSalvos}
              setAnexosSalvos={setAnexosSalvos}
              objetivos={objetivos}
              setObjetivos={setObjetivos}
              showObjetivos={showObjetivos}
              setShowObjetivos={setShowObjetivos}
              novoObjetivoTexto={novoObjetivoTexto}
              setNovoObjetivoTexto={setNovoObjetivoTexto}
              inputResponsavel={inputResponsavel}
              setInputResponsavel={setInputResponsavel}
              sugestoesResponsavel={sugestoesResponsavel}
              setSugestoesResponsavel={setSugestoesResponsavel}
              containerId={containerIdValidado}
              containerName={containerName}
              projetoAtual={projetoAtual}
              setImagemAmpliada={setImagemAmpliada}
              onNovoComentario={async (mensagem) => {
                if (!notaAtual?.id || !userId || !containerIdValidado) return;
                await supabase.from("comentarios").insert({
                  nota_id: notaAtual.id,
                  user_id: userId,
                  conteudo: mensagem,
                });
                // Se ComentariosSection tiver um reload externo, chame aqui.
                // Caso contrário, o realtime do ComentariosSection atualizará automaticamente.
              }}
            />
          )}

          {/* Informações de criação */}
          {(criadorNome && dataCriacao) && (
            <div className="task-info-criacao">
              <p>
                Tarefa criada por <strong>{criadorNome}</strong> em{" "}
                <strong>{formatarDataCriacao(dataCriacao)}</strong>
              </p>
            </div>
          )}
        </div>

        {/* ── DIVISOR REDIMENSIONÁVEL ── */}
        <div
          className={`task-col-divider${arrastandoDivisorTask ? " task-col-divider--arrastando" : ""}`}
          onMouseDown={handleDividerMouseDownTask}
        />

        {/* ── COLUNA DIREITA: Comentários ── */}
        <div className="task-col-right" style={{ width: larguraComentarios, flexShrink: 0 }}>
          {notaAtual?.id && userId && userProfile && containerIdValidado && (
            <ComentariosSection
              notaId={notaAtual.id}
              userId={userId}
              userProfile={userProfile}
              projetoAtual={projetoAtual}
              containerId={containerIdValidado}
              supabaseClient={supabase}
              setImagemAmpliada={setImagemAmpliada}
            />
          )}
        </div>
      </div>

      {/* Modal de imagem ampliada */}
      {imagemAmpliada && (
        <div
          className="imagem-ampliada-modal"
          onClick={() => setImagemAmpliada(null)}
          onKeyDown={(e) => e.key === 'Escape' && setImagemAmpliada(null)}
          tabIndex={-1}
        >
          <button className="imagem-ampliada-fechar" onClick={() => setImagemAmpliada(null)} aria-label="Fechar imagem">
            <FaTimes />
          </button>
          {imagemAmpliada.imagens.length > 1 && (
            <>
              <button className="seta-navegacao esquerda" onClick={(e) => { e.stopPropagation(); const novoIndex = (imagemAmpliada.index - 1 + imagemAmpliada.imagens.length) % imagemAmpliada.imagens.length; setImagemAmpliada({ ...imagemAmpliada, index: novoIndex }); }} aria-label="Imagem anterior">‹</button>
              <button className="seta-navegacao direita" onClick={(e) => { e.stopPropagation(); const novoIndex = (imagemAmpliada.index + 1) % imagemAmpliada.imagens.length; setImagemAmpliada({ ...imagemAmpliada, index: novoIndex }); }} aria-label="Próxima imagem">›</button>
            </>
          )}
          <div className="imagem-ampliada-wrapper">
            <img src={imagemAmpliada.imagens[imagemAmpliada.index]?.file_url} alt={imagemAmpliada.imagens[imagemAmpliada.index]?.file_name || "Imagem"} />
          </div>
        </div>
      )}
    </div>
  );
}